var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRegularInsp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.476 7.478v4.738l4.046 2.402-.671 1.146-4.738-2.877V7.478zM12 19.226q1.947 0 3.635-.995a7 7 0 0 0 2.596-2.596A7.03 7.03 0 0 0 19.226 12q0-1.947-.995-3.635a7 7 0 0 0-2.596-2.596A7.03 7.03 0 0 0 12 4.774q-1.947 0-3.635.995A7 7 0 0 0 5.77 8.365 7.03 7.03 0 0 0 4.774 12q0 1.947.995 3.635a7 7 0 0 0 2.596 2.596 7.03 7.03 0 0 0 3.635.995M12 3q2.466 0 4.565 1.233a8.53 8.53 0 0 1 3.202 3.202A8.85 8.85 0 0 1 21 12a8.85 8.85 0 0 1-1.233 4.565 8.53 8.53 0 0 1-3.202 3.202A8.85 8.85 0 0 1 12 21a8.85 8.85 0 0 1-4.565-1.233 8.7 8.7 0 0 1-3.202-3.224A8.8 8.8 0 0 1 3 12q0-2.445 1.233-4.543a8.86 8.86 0 0 1 3.224-3.224A8.8 8.8 0 0 1 12 3",
  clipRule: "evenodd"
})));
export default SvgRegularInsp;